import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledButtonIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  margin-right: 0.8rem;
  color: ${({ theme }) => theme.colors.white};
`;

export const StyledButtonText = styled.span`
  color: ${({ theme }) => theme.colors.white};
`;

export const StyledChangesInputWrapper = styled.div`
  margin-bottom: 1.6rem;
`;
